import { render, staticRenderFns } from "./imprimirorden.vue?vue&type=template&id=1c881ec6&scoped=true&"
import script from "./imprimirorden.vue?vue&type=script&lang=js&"
export * from "./imprimirorden.vue?vue&type=script&lang=js&"
import style0 from "./imprimirorden.vue?vue&type=style&index=0&id=1c881ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c881ec6",
  null
  
)

export default component.exports